import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Snooze } from "models";

export const useInterventionAppendSnoozeMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: Snooze) => (await ApiInstance.post("/snoozes/append", payload)).data.id,
    onSuccess: (payload, snoozeId: number) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions?.length) return;

      const interventionIdx = appointment.interventions.findIndex(({ id }) => id === payload.intervention_id);
      if (interventionIdx === -1) return;

      const intervention = appointment.interventions[interventionIdx];
      const snoozeItemHistoryIdx = intervention.snooze_history?.findIndex(({ id }) => id === snoozeId) ?? -1;

      const updatedSnoozeHistory =
        snoozeItemHistoryIdx === -1
          ? [{ ...payload, id: snoozeId }, ...(intervention.snooze_history ?? [])]
          : intervention.snooze_history?.with(snoozeItemHistoryIdx, { ...intervention.snooze_history[snoozeItemHistoryIdx], ...payload, id: snoozeId });
      if (!updatedSnoozeHistory) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        interventions: appointment.interventions.with(interventionIdx, { ...intervention, snoozed: true, snooze_history: updatedSnoozeHistory })
      });
    }
  });
